<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/r50vBk/tc-custom/9780253047250.jpg?1713386834932" alt="This image is the cover for the book God Had a Body"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">God Had a Body
      </h1>
      <p class="bookDescription body article font2">
        <b>A debut collection of poetry exploring themes of religion, human behavior, identity, marriage, family, and loss.</b><br/><br/>The mind and the body. The heavens and earth. God and animal. The speaker in <i>God had a body</i> considers how the image of a higher power is presented to her, beginning with a Catholic upbringing in Kentucky. Speckled with stars and peopled with creatures, these poems employ a trinity of sequences that address a present, past, and possible future—from a troubled reckoning with belief to loss and promise still ahead.<br/><br/>In this debut collection from Jennie Malboeuf, we observe undercurrents of violence and power, the dynamics of memory, gender, marriage, and miscarriage. At times, God is brutal. At times, delicate. Through true stories of animal savagery, <i>God had a body</i> unravels human behavior and undoes the opaque and cryptic mysteries of faith.<br/><br/><b>“There is a fierce spirituality and mordant wit in <i>God had a body</i>, Jennie Malboeuf’s first book of poems. Here is a poet with a transformative vision of divine and earthly enterprise as well as a sharp eye for the repercussions of physical detail.  Malboeuf’s use of enactments and embodiments—actions and images—startle and awaken the reader to a powerful new voice in American poetry. What a glorious debut collection.” —Stuart Dischell</b><br/><br/><b>“Salient and provoking, sensuous and cerebral, Jennie Malboeuf’s poems locate holiness in the living, dead, partial and whole creations of this planet. . . . I relish these poems and will return to them for their stories, their humor, and the ways they intertwine language and life.” —Lisa Williams</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennie Malboeuf
      </h2>
      
      <p class="authorDescription body article"><P><P>Born and raised in Kentucky, Jennie Malboeuf received a BA at Centre College and an MFA at the University of North Carolina at Greensboro. Her poems have appeared in the <I>Gettysburg Review</I>, <I>VQR</I>, the <I>Southern Review</I>, <I>Best New Poets</I>, and elsewhere. She lives in North Carolina with her husband, David, and dog, Mavis. She teaches writing at Guilford College.</P></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?506eef6a